export const moduleName = 'councilUnits';

export const COUNCIL_IMPORT_FILE_POLL_INTERVAL = 30000;

export const tabNames = Object.freeze({
  UNITS: 'units',
  RECENT_UNITS: 'recent',
  COUNCIL_IMPORT_STATUS: 'councilimportstatus',
});

export const expireDateFormat = 'MMM D, YYYY';

export const importFileStatus = Object.freeze({
  IN_QUEUE: 'In Queue',
  VALIDATING: 'Validating',
  VALIDATION_DONE: 'Validation Done',
  IN_PROCESSING_QUEUE: 'In Processing Queue',
  PROCESSING: 'Processing',
  PROCESSING_DONE: 'Processing Done',
  FILE_UPLOADED: 'File Uploaded',
  ERROR_UPLOAD: 'Error',
  ERROR_PROCESSING_DONE: 'Error Processing',
});
